import React from "react";
import "../css/PageCss/manualespage.css";

import LaatenciondeVB from "../img/La-atencion-de-VB.png";
import EtapasDeLaVenta from "../img/Etapas-de-la-venta.png";
import Procedimiento_ACM from "../img/Procedimiento_ACM.png";
import Procedimiento_ACB from "../img/Procedimiento_ACB.png";

import Header from "../components/Header";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";
import { ReactComponent as MySVG } from "../img/arrow-up.svg";

function ManualesPage() {
  return (
    <div className="ManualesPage">
      <Header />

      <div className="container-md-fluid d-flex justify-content-center">
        <div className="container custom-container mt-4">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item text-secondary">
                <Link className="link" to="/inicio">
                  Inicio
                </Link>
              </li>
              <li class="breadcrumb-item text-secondary">
                <Link className="link" to="/subcategoria">
                  Servicio
                </Link>
              </li>
              <li class="breadcrumb-item" aria-current="page">
                Atención al cliente y ventas
              </li>
            </ol>
          </nav>

          <h1 className="tPrincipalManual pt-4 pb-4">
            Atención al cliente y ventas
          </h1>
          <hr />
          <h2 className="tSecundarioManual">Objetivo</h2>
          <ul>
            <li>Transmitir confianza y calidez a nuestros clientes.</li>
            <li>Estandarizar nuestra presentación del servicio.</li>
            <li>
              Minimizar situaciones de insatisfacción en el proceso de atención
              al cliente.
            </li>
            <li>
              Incrementar nuestra cantidad de tickets, lo que se lograra
              haciendo cada vez más eficiente nuestro proceso de atención.
            </li>
            <li>
              Superar las expectativas de los clientes en cuanto a los tiempos
              de espera.
            </li>
            <li>
              Ejercitar constantemente las soluciones a cada problema que se
              presente, con el fin de lograr la eliminación de las
              ineficiencias.
            </li>
            <li>
              Favorecer el posicionamiento de la marca, a través de un servicio
              estandarizado de excelente calidad.
            </li>
          </ul>

          <h2 className="tSecundarioManual">Nuestros clientes</h2>
          <p>
            Un punto importantísimo a tener en cuenta a la hora de hacer
            esfuerzos en comunicación, es la gran importancia que tiene para
            nosotros mantener un cliente fiel y leal y esto se debe
            fundamentalmente a que nos cuesta entre cinco y seis veces más hacer
            nuevos clientes, que mantener a los que ya tenemos.
          </p>
          <p>
            La base de clientes fieles nos genera ingresos estables y mayores
            utilidades. Es una especie de activo y así lo consideramos.
          </p>
          <p>
            El tiempo, el dinero, y el esfuerzo dedicado a un cliente por lo
            general siempre están bien invertidos, intentando que nuestros
            clientes sean lo más fieles a nuestro negocio/marca, durante el
            mayor tiempo posible.
          </p>
          <p>
            Con el objetivo de brindar las mejores herramientas para que la
            atención al cliente sea excelente,{" "}
            <span className="fw-bold">VIDÓN BAR®</span> presenta una breve
            descripción de los diferentes tipos de clientes que se acercan a
            nuestro negocio, con sus características y las sugerencias para la
            atención que a <span className="fw-bold">VIDÓN BAR®</span> dieron
            excelentes resultados en su experiencia.
          </p>

          <div className="table-responsive">
            <table className="table table-bordered">
              <thead className="table-light">
                <tr>
                  <th scope="col">Tipos</th>
                  <th scope="col">Características</th>
                  <th scope="col">Sugerencias para la atención</th>
                </tr>
              </thead>
              <tbody class="">
                <tr>
                  <td>Personas solas</td>
                  <td>
                    <ul>
                      <li>Acuden para tomar algo.</li>
                      <li>Suelen sentarse en la barra.</li>
                      <li>Están fidelizados.</li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li>Ofrecer tragos o chopp.</li>
                      <li>Acudir a la venta sugestiva ofreciendo comida.</li>
                      <li>Incentivar su visita con amigos o familiares.</li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>Parejas</td>
                  <td>
                    <ul>
                      <li>
                        Grupo de 1 o 2 parejas que acuden al bar para comer o
                        tomar algo.
                      </li>
                      <li>Por lo general permanecen hasta muy tarde.</li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li>Ofrecer promociones de comida y bebidas.</li>
                      <li>
                        Permanecer atentos por cualquier pedido adicional sin
                        interrumpir demasiado.
                      </li>
                      <li>Ofrecer postres o café.</li>
                      <li>Ofrecer juegos.</li>
                      <li>
                        Entregar con la cuenta promociones para futuras visitas.
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>Grupos de amigos que se reúnen</td>
                  <td>
                    <ul>
                      <li>Suelen pedir comida y bebida para compartir.</li>
                      <li>Permanecen mucho tiempo en el bar.</li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li>Ofrecer promoción de fernet u otras y comida.</li>
                      <li>
                        Deben tirar la ruleta por premios y guardar la botella
                        para una próxima visita.
                      </li>
                      <li>Atender de forma personalizada y constante.</li>
                      <li>Ofrecer juegos o instrumentos.</li>
                      <li>
                        Con la cuenta invitar a los próximos eventos de la
                        semana.
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>Grupos de cumpleaños o eventos</td>
                  <td>
                    <ul>
                      <li>Grupo de clientes de gran consumo.</li>
                      <li>No miden lo que consumen.</li>
                      <li>Llegan temprano y se quedan hasta tarde.</li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li>Ofrecer juegos de mesa o instrumentos.</li>
                      <li>Ofrecer promociones de cumpleaños.</li>
                      <li>Brindar una atención personalizada.</li>
                      <li>
                        Consultar si quieren que les lleven bebidas en la medida
                        que se terminen, sin preguntar nuevamente.
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>Grupos que se reúnen después de trabajar o estudiar</td>
                  <td>
                    <ul>
                      <li>Llegan con ganas de tomar y relajarse.</li>
                      <li>Suelen ir justamente para consumir el 2x1.</li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li>Ofrecer los artículos en happy hour.</li>
                      <li>Recomendar comida para picar como papas o tablas.</li>
                      <li>Ofrecer juegos o instrumentos.</li>
                      <li>
                        Incentivar el consumo para que se queden mucho tiempo en
                        el bar.
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>Grupos que se reúnen después de realizar deportes</td>
                  <td>
                    <ul>
                      <li>
                        Se acercan al bar con la intención de tomar algo rápido
                        y comer algo llenador.
                      </li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li>
                        ⦁ Luego de comer intentar vender la Promoción de Fernet,
                        ya que la compra de la botella garantizará el regreso en
                        otra oportunidad.
                      </li>
                      <li>Ofrecer bebidas grandes para compartir.</li>
                      <li>
                        Se debe ofrecer lomitos; sándwiches o hamburguesas
                        individuales.
                      </li>
                      <li>
                        Luego de comer intentar vender la promoción de fernet,
                        ya que así se garantiza un regreso en otra oportunidad.
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>Grupos de trabajos o estudios</td>
                  <td>
                    <ul>
                      <li>Se acercan a estudiar o trabajar.</li>
                      <li>Necesitan un lugar con wifi, calmado e iluminado.</li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li>Ofrecer suscripción mensual a desayunos.</li>
                      <li>Ofrecer el menú del día.</li>
                      <li>Ofrecer juego de mate gratis.</li>
                      <li>
                        Incentivar su visita en otros horarios ofreciendo
                        promociones y combos.
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>Delivery o Take away</td>
                  <td>
                    <ul>
                      <li>Pide por llamada o whatsapp.</li>
                      <li>Se acerca al bar a pedir y espera el pedido.</li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li>
                        Incentivar a quien llama para que llegue al bar,
                        ofreciendo chopp en la caja del delivery.
                      </li>
                      <li>Ofrecer bebida o postre.</li>
                      <li>
                        Para quien lo busca dar regalo por el take away, por
                        ejemplo una lata de quilmes.
                      </li>
                      <li>Ser hospitalario con quien espera el pedido.</li>
                      <li>
                        Ofrecer que lo consuma en el local y se puede generar
                        una venta extra.
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p>
            Independientemente del tipo de cliente que se trate, se deberá
            regalar toc toc de tequila a aquellas mesas “tranquilas” para
            incentivar mayor consumo.
          </p>

          <h2 className="tSecundarioManual">Perfiles de clientes</h2>
          <p>
            En <span className="fw-bold">VIDÓN BAR®</span> no solo tenemos
            diferentes tipos de clientes, sino que cada uno de ellos tiene un
            perfil distinto. La importancia de distinguir perfiles radica en que
            a partir de saberlo, vamos a poder personalizar su atención, mejorar
            su experiencia y además, aplicaremos estrategias de marketing que
            terminan con su fidelización. Entonces, veamos cómo son nuestros
            clientes y cómo debemos tratarlos para que la atención sea la
            adecuada según <span className="fw-bold">VIDÓN BAR®</span>.
          </p>

          <div className="table-responsive">
            <table className="table table-bordered">
              <thead className="table-light">
                <tr>
                  <th scope="col">Perfiles</th>
                  <th scope="col">Características</th>
                  <th scope="col">Sugerencias para la atención</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Amarrete</td>
                  <td>
                    <ul>
                      <li>
                        Cliente que quiere pagar menos de lo que vale su
                        consumo.
                      </li>
                      <li>Dice que es amigo del dueño.</li>
                      <li>
                        Afirma que es un cliente frecuente y merece descuento.
                      </li>
                      <li>
                        Menciona que es su cumpleaños y que quiere un regalo.
                      </li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li>Comentar que el sistema no distingue precios.</li>
                      <li>
                        Nunca preguntar al encargado/franquiciado si realmente
                        conoce al cliente. No poner en compromiso ya que el
                        cliente “amigo” contará con una tarjeta especial.
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>Leal</td>
                  <td>
                    <ul>
                      <li>Cliente que viene al bar hace mucho.</li>
                      <li>
                        Nos elige y realiza recomendaciones a favor del
                        negocio/marca.
                      </li>
                      <li>Realiza feedback con intención de que mejoremos.</li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li>
                        Debemos conocer el nombre del cliente y sus gustos de
                        preferencias.
                      </li>
                      <li>Invitarlo en eventos y días especiales.</li>
                      <li>
                        Hacerle sentir que nos significa mucho su fidelización.
                      </li>
                    </ul>
                  </td>
                </tr>

                <tr>
                  <td>Largo</td>
                  <td>
                    <ul>
                      <li>
                        Cliente que luego de finalizar el horario de venta
                        insiste en seguir comprando.
                      </li>
                      <li>
                        Siempre pide hablar con el dueño o encargado para
                        acceder a su pedido.
                      </li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li>
                        Comentarle que está terminantemente prohibido vender
                        luego del horario permitido según la legislación de la
                        plaza.
                      </li>
                      <li>
                        El mozo deberá resolver la situación por sí solo sin
                        poner en compromiso al encargado o franquiciado.
                      </li>
                    </ul>
                  </td>
                </tr>

                <tr>
                  <td>Fiestero</td>
                  <td>
                    <ul>
                      <li>
                        Grupo de personas que reemplazan el boliche por
                        <span className="fw-bold"> VIDÓN BAR®.</span>
                      </li>
                      <li>
                        Suelen querer estar parados y comprar directamente en la
                        barra.
                      </li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li>
                        Ofrecer bebidas fuertes para incentivar mayor consumo.
                      </li>
                      <li>
                        Ofrecerles un espacio acorde para que estén parados y
                        con música alta así todos los clientes del bar están
                        cómodos.
                      </li>
                      <li>El mozo deberá tener la situación controlada.</li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <h2 className="tSecundarioManual">
            La atención de nuestros clientes
          </h2>
          <p>
            Siempre estamos trabajando pensando en la satisfacción de nuestro
            cliente, es por eso que el siguiente esquema permite analizar cuáles
            son los atributos que valora un cliente cuando entra en contacto con
            <span className="fw-bold"> VIDÓN BAR®</span>.
          </p>
          <p>
            Veamos cuáles son esas actitudes claves de la atención al cliente:
          </p>

          <div className="row p-4">
            <div className="col-md-6">
              <img class="diagrama2" src={LaatenciondeVB} />
            </div>
            <div className="col-md-6">
              <div className="d-flex justify-content-center align-items-center h-100">
                <div>
                  <p>
                    Como consecuencia de satisfacer las necesidades de nuestros
                    clientes durante su estadía lograremos la mejor publicidad
                    boca a boca.
                  </p>
                  <p>
                    Un cliente comenta sus buenas experiencias a 3 personas de
                    su entorno. En cambio, una mala experiencia se comentará a
                    9.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <p>
            A partir de esto, profundizaremos sobre estos momentos críticos
            durante la visita de nuestros clientes.
          </p>
          <h2 className="tSecundarioManual">Momentos de la verdad</h2>
          <p>
            Durante el paso de nuestros clientes por{" "}
            <span className="fw-bold">VIDÓN BAR®</span>, atraviesan cuatro
            momentos claves durante su estadía. Estos momentos, son tan críticos
            porque forman una opinión acerca de nuestra atención y el cliente
            está evaluando constantemente nuestro desempeño.
          </p>
          <p>
            Como ya hemos mencionado, estos momentos deben satisfacer sus
            necesidades pero también superar expectativas. La misión de VIDON
            BAR es que nuestros clientes siempre quieran regresar y que realicen
            una buena recomendación de boca en boca.
          </p>

          <p>Veamos en detalle cada momento de la verdad:</p>

          <ol>
            <li>
              <h4 className="tSecundarioManual">Bienvenida</h4>
              <p>
                El primer contacto es vital para la fidelización del cliente. Es
                la primera impresión que el cliente tendrá con la empresa y por
                lo tanto debe ser excelente. Debemos mirar a nuestros clientes
                como invitados, por lo tanto tienen que sentir que los estábamos
                esperando.
              </p>
              <p>
                El saludo inicial cuando se recibe al cliente debe realizarse de
                la siguiente forma:
              </p>
              <ul>
                <li>Con actitud positiva</li>
                <li>Con amabilidad y respeto</li>
                <li>Sonriendo y mirando a los ojos al cliente</li>
              </ul>
              <p>A continuación un ejemplo:</p>

              <div className="p-2 d-flex justify-content-center align-items-center">
                <div className="card cardManual mb-3">
                  <div className="card-header cardManual-header">
                    <h5 className="text-center">
                      <svg
                        className="mb-2"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width={24}
                        height={24}
                        color={"#000000"}
                        fill={"none"}
                      >
                        <path
                          d="M21.8606 5.39176C22.2875 6.49635 21.6888 7.2526 20.5301 7.99754C19.5951 8.5986 18.4039 9.24975 17.1417 10.363C15.9044 11.4543 14.6968 12.7687 13.6237 14.0625C12.5549 15.351 11.6465 16.586 11.0046 17.5005C10.5898 18.0914 10.011 18.9729 10.011 18.9729C9.60281 19.6187 8.86895 20.0096 8.08206 19.9998C7.295 19.99 6.57208 19.5812 6.18156 18.9251C5.18328 17.248 4.41296 16.5857 4.05891 16.3478C3.11158 15.7112 2 15.6171 2 14.1335C2 12.9554 2.99489 12.0003 4.22216 12.0003C5.08862 12.0323 5.89398 12.373 6.60756 12.8526C7.06369 13.1591 7.54689 13.5645 8.04948 14.0981C8.63934 13.2936 9.35016 12.3653 10.147 11.4047C11.3042 10.0097 12.6701 8.51309 14.1349 7.22116C15.5748 5.95115 17.2396 4.76235 19.0042 4.13381C20.1549 3.72397 21.4337 4.28718 21.8606 5.39176Z"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      &nbsp;SALUDO CORRECTO
                    </h5>
                  </div>
                  <div className="card-body">
                    <p className="card-text">
                      <ul>
                        <li className="fw-bold">
                          "Buenas Noches, ¿Cómo andan? ¿Cuántos van a ser hoy?"
                        </li>
                        <li>
                          Si entran clientes luego de las 1 AM comentar que la
                          cocina está abierta{" "}
                          <span className="fw-bold">
                            "Buenas Noches, ¿Cómo andan?, Recuerden que la
                            cocina esta siempre abierta"
                          </span>
                        </li>
                      </ul>
                    </p>
                  </div>
                </div>
              </div>
              <p>
                Esta bienvenida continua cuando el cliente está ubicado en su
                mesa y la atención es del mozo que lo atenderá. El mozo deberá:
              </p>
              <ul>
                <li>Presentarse cordialmente con su nombre.</li>
                <li>
                  Actuar con empatía para continuar con la fidelización del
                  cliente.
                </li>
                <li>
                  Identificar al tipo de cliente para saber cómo personalizar su
                  atención.
                </li>
              </ul>
              <p>También veremos un ejemplo:</p>
              <div className="p-2 d-flex justify-content-center align-items-center">
                <div className="card cardManual mb-3">
                  <div className="card-header cardManual-header">
                    <h5 className="text-center">
                      <svg
                        className="mb-2"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width={24}
                        height={24}
                        color={"#000000"}
                        fill={"none"}
                      >
                        <path
                          d="M21.8606 5.39176C22.2875 6.49635 21.6888 7.2526 20.5301 7.99754C19.5951 8.5986 18.4039 9.24975 17.1417 10.363C15.9044 11.4543 14.6968 12.7687 13.6237 14.0625C12.5549 15.351 11.6465 16.586 11.0046 17.5005C10.5898 18.0914 10.011 18.9729 10.011 18.9729C9.60281 19.6187 8.86895 20.0096 8.08206 19.9998C7.295 19.99 6.57208 19.5812 6.18156 18.9251C5.18328 17.248 4.41296 16.5857 4.05891 16.3478C3.11158 15.7112 2 15.6171 2 14.1335C2 12.9554 2.99489 12.0003 4.22216 12.0003C5.08862 12.0323 5.89398 12.373 6.60756 12.8526C7.06369 13.1591 7.54689 13.5645 8.04948 14.0981C8.63934 13.2936 9.35016 12.3653 10.147 11.4047C11.3042 10.0097 12.6701 8.51309 14.1349 7.22116C15.5748 5.95115 17.2396 4.76235 19.0042 4.13381C20.1549 3.72397 21.4337 4.28718 21.8606 5.39176Z"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      &nbsp;ATENCIÓN CORRECTA
                    </h5>
                  </div>
                  <div className="card-body">
                    <p className="card-text">
                      <ul>
                        <li className="fw-bold">
                          "Hola, ¿Cómo están?, Mi nombre es Ignacio y voy a ser
                          su mozo hoy"
                        </li>
                        <li className="fw-bold">
                          "Les dejo más maní, cualquier cosita me avisan"
                        </li>
                      </ul>
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-light rounded-2 p-4">
                <p className="underline">
                  Las expectativas del cliente se cumplen si:
                </p>
                <ul>
                  <li>Lo recibimos y lo ubicamos en donde él desea.</li>
                  <li>Si el mozo es lo suficientemente amable.</li>
                </ul>
              </div>
            </li>
            <li>
              <h4 className="tSecundarioManual">Primer pedido</h4>
              <p>
                La toma de pedido es el momento fundamental para ofrecer
                productos adicionales o complementarios que eleven el valor del
                ticket final.
              </p>
              <p>
                La venta sugestiva es una herramienta de gran alcance que puede
                aumentar la rentabilidad de cualquier tipo de negocio. El
                cliente compra lo que sabe que tenemos. La venta sugestiva trata
                de completar esa compra con algo que pueda resultar atrayente.
                Se trata de sugerir al cliente productos adicionales a su compra
                inicial.
              </p>
              <p>
                El momento de toma de pedido sirve para realizar la venta
                sugestiva. Para tal fin{" "}
                <span className="fw-bold">VIDÓN BAR®</span> desarrolló una tabla
                como guía para ofrecer productos, de acuerdo a la compra que
                realice el cliente.
              </p>

              <table className="table mt-5 mb-5">
                <thead>
                  <tr>
                    <th>Si compra...</th>
                    <th>Ofrecer</th>
                  </tr>
                </thead>
                <tbody class="table-group-divider">
                  <tr>
                    <td>Cerveza</td>
                    <td>Pizza o tabla de picada para acompañar</td>
                  </tr>
                  <tr>
                    <td>Papas</td>
                    <td>Papas Vidón, con huevo, etc</td>
                  </tr>
                  <tr>
                    <td>Fernet</td>
                    <td>Promo fernet + cocas</td>
                  </tr>
                  <tr>
                    <td>Pizza</td>
                    <td>Cerveza</td>
                  </tr>
                  <tr>
                    <td>Comida</td>
                    <td>Trago o postre con la cuenta</td>
                  </tr>
                </tbody>
              </table>
              <p>
                Durante este primer pedido, el cliente y el mozo pasan por las
                <span className="fw-bold"> ETAPAS DE LA VENTA</span>, pasos que
                como punto final tienen la toma del pedido, los vemos a
                continuación:
              </p>

              <img className="diagrama" src={EtapasDeLaVenta} />

              <p>
                Estas etapas se desarrollan cada vez que el cliente necesita
                realizar un pedido.
              </p>
              <div className="bg-light rounded-2 p-4">
                <p className="underline">En este punto el cliente evalúa:</p>
                <ul>
                  <li>Los tiempos de entrega.</li>
                  <li>Si tiene todo lo necesario para el consumo.</li>
                  <li>Que el producto cumpla con lo que le prometemos.</li>
                </ul>
              </div>
            </li>
            <li>
              <h4 className="tSecundarioManual">Atención constante</h4>
              <p>
                La atención constante es la mayor oportunidad que tenemos en
                <span className="fw-bold"> VIDÓN BAR®</span> para fidelizar
                clientes.
              </p>
              <p>
                El cliente necesita satisfacer una necesidad y en este momento
                nosotros superamos su expectativa llegando al deleite de la
                atención al cliente.
              </p>
              <p>
                Existen mesas que pasan muchas horas en{" "}
                <span className="fw-bold">VIDÓN BAR®</span> y eso es posible
                gracias al seguimiento y atención que realizan nuestros mozos.
                Es fundamental estar atentos a lo que el cliente necesita y a la
                cantidad de productos que tenga en la mesa para poder ofrecer
                más. Uno de los objetivos del negocio/marca es generar ventas.
              </p>
              <p>
                Nuestros <a href="#">generadores de valor</a> son recursos que
                aumentan la capacidad de crear valor a clientes, franquiciados y
                trabajadores. Además, son fundamentales para la estrategia de la
                empresa ya que nos permiten diferenciarnos de la competencia y
                lograr un crecimiento sostenible.
              </p>
              <p>
                Los generadores de valor son una herramienta de alto alcance que
                pueden aumentar las ventas y por ende el ticket final. En
                ocasiones el incremento en las ventas son una consecuencia de
                esta atención constante.
              </p>
              <p>Veamos algunos ejemplos:</p>

              <table className="table mt-5 mb-5">
                <thead>
                  <tr>
                    <th>Atención tradicional</th>
                    <th>Atención recomendada</th>
                  </tr>
                </thead>
                <tbody class="table-group-divider">
                  <tr>
                    <td>Chicos, ¿Todo bien? ¿Les traigo una cerveza?</td>
                    <td>
                      ¿Como va? Les traemos un jenga para que hagamos un
                      campeonato.
                    </td>
                  </tr>
                  <tr>
                    <td>Piden la cuenta y queda fernet</td>
                    <td>Ofrecer guardarlo para una proxima visita.</td>
                  </tr>
                  <tr>
                    <td>Si hay niños en la mesa</td>
                    <td>
                      Ofrecer sillita para niños, juegos, lápices y dibujos para
                      pintar.
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="bg-light rounded-2 p-4">
                <p className="underline">
                  Las expectativas del cliente se superan si:
                </p>
                <ul>
                  <li>Estamos atentos a sus necesidades</li>
                  <li>
                    Ofrecemos más de lo que él espera, ofreciendo generadores de
                    valor.
                  </li>
                  <li>
                    La pasa mejor de lo que pensaba, o sea si llegamos al
                    deleite en la atención al cliente.
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <h4 className="tSecundarioManual">Cierre</h4>
              <p>
                Aunque el cliente haya decidido irse, su experiencia aún no ha
                terminado. Este momento es crucial porque nos da la oportunidad
                de reforzar los tres momentos anteriores de su visita, y no
                debemos hacer lo contrario. Un cliente con un desarrollo
                perfecto de su visita también desea que su retirada cumpla con
                sus expectativas.
              </p>
              <p>
                El cierre de una mesa con clientes es fundamental y debe hacerse
                con rapidez y precisión. Es el momento perfecto para entregar
                promociones y publicidad según el tipo de cliente, invitándolos
                a regresar en los próximos días o eventos.
              </p>
              <p>
                {" "}
                La despedida, debe incluir un agradecimiento amable acompañado
                de una sonrisa y mirando a los ojos a los clientes. Por ejemplo:
              </p>
              <div className="p-2 d-flex justify-content-center align-items-center">
                <div className="card cardManual mb-3">
                  <div className="card-header cardManual-header">
                    <h5 className="text-center">
                      <svg
                        className="mb-2"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width={24}
                        height={24}
                        color={"#000000"}
                        fill={"none"}
                      >
                        <path
                          d="M21.8606 5.39176C22.2875 6.49635 21.6888 7.2526 20.5301 7.99754C19.5951 8.5986 18.4039 9.24975 17.1417 10.363C15.9044 11.4543 14.6968 12.7687 13.6237 14.0625C12.5549 15.351 11.6465 16.586 11.0046 17.5005C10.5898 18.0914 10.011 18.9729 10.011 18.9729C9.60281 19.6187 8.86895 20.0096 8.08206 19.9998C7.295 19.99 6.57208 19.5812 6.18156 18.9251C5.18328 17.248 4.41296 16.5857 4.05891 16.3478C3.11158 15.7112 2 15.6171 2 14.1335C2 12.9554 2.99489 12.0003 4.22216 12.0003C5.08862 12.0323 5.89398 12.373 6.60756 12.8526C7.06369 13.1591 7.54689 13.5645 8.04948 14.0981C8.63934 13.2936 9.35016 12.3653 10.147 11.4047C11.3042 10.0097 12.6701 8.51309 14.1349 7.22116C15.5748 5.95115 17.2396 4.76235 19.0042 4.13381C20.1549 3.72397 21.4337 4.28718 21.8606 5.39176Z"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      &nbsp;ATENCIÓN CORRECTA
                    </h5>
                  </div>
                  <div className="card-body">
                    <p className="card-text">
                      <ul>
                        <li className="fw-bold">
                          "¡Chau chicos, gracias por venir! ¡Los esperamos de
                          nuevo!"
                        </li>
                        <li className="fw-bold">
                          "¡Nos vemos!, No se olviden que mañana tenemos bingo."
                        </li>
                      </ul>
                    </p>
                  </div>
                </div>
              </div>
              <p>
                Además, es cliente valorará mucho que le preguntemos como la
                paso porque denota que nos interesa en{" "}
                <span className="fw-bold"> VIDÓN BAR®</span> como la pasan
                nuestros clientes. Si el cliente ha tenido una buena
                experiencia, tenemos la oportunidad ideal para pedirles que
                dejen una recomendación en{" "}
                <a href="https://www.google.com/search?sca_esv=b4340eee26af1ee7&sxsrf=ADLYWIKnA7NWTGZ6Zr1-di3ZsdfnMBw71w:1716926042673&q=vidon+bar&spell=1&sa=X&ved=2ahUKEwif74P3j7GGAxVfqZUCHXNGA4cQBSgAegQIEhAB&biw=1366&bih=639&dpr=1&lqi=Cgl2aWRvbiBiYXJI1OPzsqyPgIAIWhMQABABGAAYASIJdmlkb24gYmFykgEDYmFyqgExEAEyHhABIhreQsDRWRYu3gRt29fCkS1fuFKC_I9k2L31cjINEAIiCXZpZG9uIGJhcg#lrd=0x9432986801df9de3:0x92defe9bc8fffc15,3,,,,&rlimm=10583176119412849685">
                  Google
                </a>{" "}
                o{" "}
                <a href="https://www.tripadvisor.com.ar/UserReviewEdit-g312768-d6509029-Vidon_Bar-Cordoba_Province_of_Cordoba_Central_Argentina.html">
                  TripAdvisor
                </a>{" "}
                ya que su opinión nos ayuda a mejorar nuestra atención.
              </p>

              <div className="bg-light rounded-2 p-4">
                <p className="underline">El cliente espera que:</p>
                <ul>
                  <li>Cobremos su mesa con rapidez y exactitud.</li>
                  <li>Le preguntemos cómo estuvo el servicio.</li>
                  <li>Ofrezcamos invitaciones para una próxima vez.</li>
                  <li>Agradezcamos por su visita.</li>
                </ul>
              </div>
            </li>
          </ol>

          <h2 className="tSecundarioManual">
            Procedimiento de atención al cliente en mesa
          </h2>
          <p>
            A continuación veremos el procedimiento que se debe llevar a cabo
            cada vez que tenemos un cliente en un{" "}
            <span className="fw-bold"> VIDÓN BAR®</span>.
          </p>

          <img className="diagrama" src={Procedimiento_ACM} />

          <h4 className="tSecundarioManual">
            <svg
              className="mb-1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width={24}
              height={24}
              color={"#000000"}
              fill={"none"}
            >
              <path
                d="M13 4H6.23456C3.79424 4 2.57407 4 2.14438 4.76649C2.13129 4.78984 2.11883 4.81353 2.10701 4.83754C1.71893 5.62592 2.41032 6.63129 3.7931 8.64204C4.89612 10.246 5.44763 11.048 5.4611 11.9555C5.46154 11.9852 5.46154 12.0148 5.4611 12.0445C5.44763 12.952 4.89612 13.754 3.7931 15.358C2.41032 17.3687 1.71893 18.3741 2.10701 19.1625C2.11883 19.1865 2.13129 19.2102 2.14438 19.2335C2.57407 20 3.79424 20 6.23456 20H13C14.9628 20 15.9443 20 16.7889 19.5777C17.6334 19.1554 18.2223 18.3703 19.4 16.8C21.1333 14.4889 22 13.3333 22 12C22 10.6667 21.1333 9.51111 19.4 7.2C18.2223 5.62972 17.6334 4.84458 16.7889 4.42229C15.9443 4 14.9628 4 13 4Z"
                stroke="currentColor"
                strokeWidth="1.5"
              />
            </svg>
            &nbsp;Instructivo de situaciones frecuentes en la atención al
            cliente en MESA:
          </h4>

          <p>
            Con el objetivo de acercar las mejores herramientas de ventas para
            nuestros franquiciados, es que a continuación presentamos un listado
            de situaciones que se presentan en nuestros locales y que fueron
            formando nuestra experiencia en la mejor atención y respuesta a cada
            inquietud o actitud del cliente.
          </p>

          <div className="table-responsive">
            <table className="table table-bordered">
              <thead className="text-center">
                <tr>
                  <th className="table-dosheader" scope="col" colSpan="2">
                    Situaciones frecuentes de la atención en mesas
                  </th>
                </tr>
              </thead>
              <tbody className="text-center">
                <tr>
                  <td colSpan="2">
                    El responsable de recibir los reclamos es el{" "}
                    <span className="fw-bold">MOZO</span> responsable de la
                    mesa.
                  </td>
                </tr>
              </tbody>
              <thead className="table-light text-center">
                <tr>
                  <th scope="col">Situación Posible | Frecuente</th>
                  <th scope="col">Acción que recomendamos tomar</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <ul>
                      <li>El cliente reclama por la demora de su pedido.</li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li>Ante todo , primero ofrecer disculpas.</li>
                      <li>
                        Ofrecer promociones o descuentos para futuras visitas.
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>
                    <ul>
                      <li>
                        El cliente ha tomado demasiado e insiste violentamente
                        en comprar más.
                      </li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li>
                        Tranquilizar al cliente explicando que ya tomó demasiado
                        y que por política del bar no se puede continuar
                        vendiendo.
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>
                    <ul>
                      <li>Si se corta la luz.</li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li>
                        Iluminar la barra y cada una de las mesas ocupadas con
                        velas.
                      </li>
                      <li>
                        Entregar el ticket al cliente informando que el bar
                        continúa abierto.
                      </li>
                      <li>Registrar operaciones manualmente.</li>
                      <li>
                        Si el problema es interno, comunicarse inmediatamente
                        con el responsable de mantenimiento.
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>
                    <ul>
                      <li>
                        Si hay faltante del producto que el cliente quiere.
                      </li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li>
                        Acudir a una segunda opción de venta con bienes
                        sustitutos.
                      </li>
                      <li>El bar nunca deberá quedarse sin mercadería.</li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>
                    <ul>
                      <li>
                        El cliente se queja que la cerveza no tiene gas o está
                        caliente.
                      </li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li>Pedir disculpas y cambiarla por una nueva.</li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>
                    <ul>
                      <li>Se genera una pelea entre clientes.</li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li>
                        El encargado deberá intervenir separando las mesas en
                        dos sectores diferentes.
                      </li>
                      <li>
                        Comunicar a ambas mesas que{" "}
                        <span className="fw-bold">VIDÓN BAR®</span> es un lugar
                        para pasarla bien, que terminen el conflicto o de lo
                        contrario se dará aviso a la policía.
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>
                    <ul>
                      <li>
                        Se genera una discusión entre un MOZO y un cliente.
                      </li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li>El mozo en cuestión deberá llamar al encargado.</li>
                      <li>
                        El encargado deberá solucionar el problema, pidiendo
                        disculpas del caso, cambiando el mozo de ese sector.
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>
                    <ul>
                      <li>Si el producto no es lo que espera el cliente.</li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li>Consultar que es lo que no está bien del pedido.</li>
                      <li>Rehacer el pedido como debe ser.</li>
                      <li>En ningún caso cobrar.</li>
                    </ul>
                  </td>
                </tr>
              </tbody>
              <tfoot className="text-center table-light">
                <tr>
                  <td className="fw-bold" colSpan="2">
                    El cliente siempre debe retirarse del bar habiendo pasado un
                    buen momento.
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>

          <h2 className="tSecundarioManual">
            Procedimiento de atención al cliente en barra
          </h2>
          <p>
            En <span className="fw-bold">VIDÓN BAR®</span>, en ocasiones
            contamos con clientes que prefieren sentarse en la barra o ir a
            buscar su trago a la barra por el motivo que sea.
          </p>
          <p>Es por esto que veremos como se debe dar esa atención:</p>

          <img className="diagrama" src={Procedimiento_ACB} />

          <h4 className="tSecundarioManual">
            <svg
              className="mb-1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width={24}
              height={24}
              color={"#000000"}
              fill={"none"}
            >
              <path
                d="M13 4H6.23456C3.79424 4 2.57407 4 2.14438 4.76649C2.13129 4.78984 2.11883 4.81353 2.10701 4.83754C1.71893 5.62592 2.41032 6.63129 3.7931 8.64204C4.89612 10.246 5.44763 11.048 5.4611 11.9555C5.46154 11.9852 5.46154 12.0148 5.4611 12.0445C5.44763 12.952 4.89612 13.754 3.7931 15.358C2.41032 17.3687 1.71893 18.3741 2.10701 19.1625C2.11883 19.1865 2.13129 19.2102 2.14438 19.2335C2.57407 20 3.79424 20 6.23456 20H13C14.9628 20 15.9443 20 16.7889 19.5777C17.6334 19.1554 18.2223 18.3703 19.4 16.8C21.1333 14.4889 22 13.3333 22 12C22 10.6667 21.1333 9.51111 19.4 7.2C18.2223 5.62972 17.6334 4.84458 16.7889 4.42229C15.9443 4 14.9628 4 13 4Z"
                stroke="currentColor"
                strokeWidth="1.5"
              />
            </svg>
            &nbsp;Instructivo de situaciones frecuentes en la atención al
            cliente en BARRA:
          </h4>

          <p>
            También, a continuación presentamos el listado de las situaciones
            que se presentan en las barras de{" "}
            <span className="fw-bold">VIDÓN BAR®</span>.
          </p>

          <div className="table-responsive">
            <table className="table table-bordered">
              <thead className="text-center">
                <tr>
                  <th className="table-dosheader" scope="col" colSpan="2">
                    Situaciones frecuentes de la atención en barra
                  </th>
                </tr>
              </thead>
              <tbody className="text-center">
                <tr>
                  <td colSpan="2">
                    El responsable de recibir los reclamos es el{" "}
                    <span className="fw-bold">BARTENDER</span> responsable de la
                    mesa.
                  </td>
                </tr>
              </tbody>
              <thead className="table-light text-center">
                <tr>
                  <th scope="col">Situación Posible | Frecuente</th>
                  <th scope="col">Acción que recomendamos tomar</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <ul>
                      <li>
                        El cliente regresa al sector de barra reiteradas veces
                        para que el bartender recargue su trago.
                      </li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li>Cargar una sola vez más (pequeña cantidad).</li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>
                    <ul>
                      <li>
                        El cliente regresa, porque no le gusta como está hecho
                        el trago.
                      </li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li>Ofrecer preparar nuevamente el trago que pidió.</li>
                      <li>Ofrecer otro trago más suave y dulce.</li>
                      <li>En ningún caso cobrarle.</li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>
                    <ul>
                      <li>
                        El cliente bloquea el paso a la barra para los mozos.
                      </li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li>
                        Ofrecerle cordialmente una mesa, liberando el espacio a
                        los mozos.
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
              <tfoot className="text-center table-light">
                <tr>
                  <td className="fw-bold" colSpan="2">
                    El cliente siempre debe retirarse del bar habiendo pasado un
                    buen momento.
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>

          <div className="d-flex justify-content-between pt-2 pb-2">
            <div>
              <a className="aNegro" href="#">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                  color="#000000"
                  fill="none"
                >
                  <path
                    d="M4 12L20 12"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M8.99996 17C8.99996 17 4.00001 13.3176 4 12C3.99999 10.6824 9 7 9 7"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                Anterior manual
              </a>
            </div>
            <div>
              <a className="aNegro" href="#">
                Siguiente manual
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                  color="#000000"
                  fill="none"
                >
                  <path
                    d="M20 12L4 12"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M15 17C15 17 20 13.3176 20 12C20 10.6824 15 7 15 7"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>

      <ScrollToTop
        smooth
        component={<MySVG />}
        style={{
          border: "solid 2px black",
          borderRadius: "50%",
          paddingBottom: "5px",
        }}
      />
      <Footer />
    </div>
  );
}

export default ManualesPage;
